import { useMutation } from "@tanstack/react-query";
import { exportRfxIndividualResponse, exportRfxAllResponses } from "../api/rfx-report-api";
import type { RfxReportExportResponse } from "../types";

export const useRfxIndividualResponseExport = () => {
	return useMutation<RfxReportExportResponse, Error, { rfxId: number; inviteId: number }>({
		mutationFn: ({ rfxId, inviteId }) => exportRfxIndividualResponse(rfxId, inviteId),
		onSuccess: (data) => {
			window.open(data.download_url, "_blank");
		},
	});
};

export const useRfxAllResponsesExport = () => {
	return useMutation<RfxReportExportResponse, Error, number>({
		mutationFn: (rfxId: number) => exportRfxAllResponses(rfxId),
		onSuccess: (data) => {
			window.open(data.download_url, "_blank");
		},
	});
};
